// extracted by mini-css-extract-plugin
module.exports = {"settings":"Settings_settings__2Z5V_","settings-submit":"Settings_settings-submit__4lI-L"};